module.exports = {
  BackToMain: 'กลับไปหน้าหลัก',
  UserInfo: 'ข้อมูลส่วนตัว',
  Individual: 'ปรับแต่งหน้า',
  Cache: 'แคช',
  Authorize: 'อนุญาต',
  CNName: 'ชื่อจีน:',
  Phone: 'มือถือ:',
  ENName: 'ชื่อภาษาอังกฤษ:',
  Tel: 'โทรศัพท์:',
  Email: 'อีเมล:',
  QQ: 'QQ:',
  MyInfo: 'ข้อมูลส่วนบุคคล',
  PersonalEmailSettings: 'การตั้งค่าอีเมลส่วนตัว',
  EmailPassword: 'รหัสผ่านอีเมล/รหัสอนุญาต:',
  SignatureSetup: 'การตั้งค่าลายเซ็น',
  ToEnableTheSignature: 'เปิดใช้งานลายเซ็น',
  SendTest: 'ส่งทดสอบ',
  Edit: 'แก้ไข',
  Save: 'บันทึก',
  Cancel: 'ยกเลิก',
  ChangePsd: 'เปลี่ยนรหัสผ่าน',
  ErrorRaised: 'เกิดข้อผิดพลาด',
  SaveSucceed: 'บันทึกสำเร็จ',
  ResetJobCopySucceed: 'สามารถตั้งค่าเงื่อนไขการคัดลอกหน้ากลับได้แล้ว',
  CancelChange: 'ยืนยันยกเลิกการแก้ไขปัจจุบัน?',
  Name: 'ชื่อ',
  company: 'บริษัท',
  platformId: 'ไอดีแพลตฟอร์ม',
  department: 'แผนก',
  Version: 'เวอร์ชัน',
  Amount: 'ทั้งหมด',
  Filter: 'ค้นหา:',
  RefreshCache: 'รีเฟรชแคช',
  ResetCache: 'รีเซ็ตแคช',
  Refresh: 'รีเฟรช',
  Reset: 'รีเซ็ต',
  Detail: 'ดู',
  UserName: 'ชื่อ-นามสกุล',
  LoginTime: 'เวลาล็อกอิน',
  ExitTime: 'การดำเนินการล่าสุด',
  BackToMyAccount: 'ออกจากบัญชีที่ได้รับอนุญาต',
  AuthHistory: 'ประวัติการใช้สิทธิ์',
  User: 'ผู้ใช้',
  NewAuth: 'อนุญาต',
  BeginDate: 'วันที่เริ่ม',
  EndDate: 'วันที่สิ้นสุด',
  CancalAuth: 'เพิกถอนการอนุญาต',
  UseAuth: 'ใช้สิทธิ์',
  AuthOwned: 'สิทธิ์ที่มีอยู่ในปัจจุบัน',
  AuthFail: 'การอนุญาตล้มเหลว',
  ConfirmAuth: 'ยืนยันการอนุญาต',
  InputAuthReason: 'กรุณาใส่เหตุผลในการอนุญาต',
  AdminUse: 'ผู้ดูแลระบบเข้าสู่ระบบ:',
  InvalidUser: 'กรุณาใส่ชื่อผู้ใช้และวันที่ให้ถูกต้อง!',
  AuthMyself: 'ไม่สามารถอนุญาตให้ตัวเองได้!',
  InputUser: 'กรุณาใส่ชื่อผู้ใช้ที่ต้องการอนุญาต!',
  Tips: 'คำเตือน',
  SaveYourChange: 'มีการเปลี่ยนแปลงข้อมูลที่ยังไม่ได้บันทึก โปรดปิดโมดูลทั้งหมดที่เปิดอยู่ก่อนออกจากบัญชีผู้ใช้ที่ได้รับอนุญาต!',
  ShutModule: 'โปรดปิดโมดูลที่เปิดอยู่ก่อนออกจากบัญชีผู้ใช้ที่ได้รับอนุญาต ขณะนี้เปิดอยู่ {0} โมดูล ต้องการปิดทั้งหมดหรือไม่?',
  LoginMySelf: 'ไม่จำเป็นต้องเข้าสู่ระบบบัญชีของตัวเองซ้ำ!',
  SelectAccout: 'กรุณาใส่บัญชีผู้ใช้ที่ต้องการเข้าสู่ระบบ!',
  TableColor: 'สีตาราง',
  StatusName: 'ชื่อสถานะ',
  ColorValue: 'ค่าสี',
  PartnerDisplayControl: 'การควบคุมการแสดงข้อมูล',
  PartnerCategory: 'ประเภทข้อมูล',
  Chinese: 'ภาษาจีน',
  English: 'ภาษาอังกฤษ',
  Code: 'รหัส',
  EnglishAndChinese: 'ภาษาอังกฤษ+ภาษาจีน',
  ChineseAndEnglish: 'ภาษาจีน+ภาษาอังกฤษ',
  ShortName: 'ชื่อย่อ',
  CodeAndChinese: 'รหัส+ภาษาจีน',
  CodeAndEnglish: 'รหัส+ภาษาอังกฤษ',
  ShortNameAndChinese: 'ชื่อย่อ+ภาษาจีน',
  YouDoNotHaveAccessToTheAdministratorAccount: 'คุณไม่มีสิทธิ์เข้าถึงบัญชีผู้ดูแลระบบ',
  Setting: 'ต.ค.',
  VerificationSettings: 'ตั้งค่า Pop-up ตรวจสอบ',
  ResetJobCopyTittle: 'ตั้งค่าเงื่อนไขหน้าจอใหม่',
  ResetJobCopyMessage: 'หลังจากคลิกปุ่มตั้งค่า เมื่อทำการคัดลอก จะแสดงกล่องโต้ตอบตั้งค่าเงื่อนไขการคัดลอกอีกครั้ง สามารถตั้งค่าเงื่อนไขการคัดลอกใหม่ได้',
  RepeatCopyMessage: 'มีชื่อค่าบริการที่ซ้ำกันอยู่ ต้องการคัดลอกอีกครั้งหรือไม่?',
  WeChatPushRemindTitle: 'กรุณาสแกน QR Code ด้านล่าง และติดตามบัญชี "WallTech ข้อมูล Woohang"',
  WeChatPushRemind1: 'โปรดตรวจสอบว่าคุณได้ติดตามบัญชี "WallTech ข้อมูล Woohang" แล้ว มิฉะนั้นจะไม่สามารถรับข้อความ WeChat ได้',
  WeChatPushRemind2: 'การแจ้งเตือนผ่าน WeChat อาจมีความล่าช้า ข้อมูลทั้งหมดให้ยึดตามที่แสดงในเว็บไซต์',
  IveFollowed: 'ฉันได้ติดตามแล้ว',
  CheckedCategory: 'ประเภทตัวเลือกที่เลือก',
  AfterCheckedSelection: 'หลังจากคลิกปุ่มรีเซ็ต เมื่อทำการประกันภัย จะแสดงหน้าเลือกตัวแทนอีกครั้ง สามารถตั้งค่าตัวเลือกตัวแทนใหม่ได้',
  FreightInsuranceProvider: 'ผู้ให้บริการประกันภัยขนส่งสินค้า',
  ResetFreightInsuranceProvider: 'รีเซ็ตผู้ให้บริการประกันภัยขนส่งสินค้า',
  FreightInsuranceProviderReset: 'ได้รีเซ็ตตัวเลือกผู้ให้บริการประกันภัยขนส่งสินค้าแล้ว',
  CopyBusiness: 'คัดลอกธุรกิจ',
  UseSsl: 'เปิดใช้งานโหมด SSL',
  Japanese: 'ภาษาญี่ปุ่น',
  CustomerSupplierNoChinese: 'รหัสลูกค้า/รหัสผู้จัดหา+ภาษาจีน',
  threeCharacterCode: 'ชื่อย่อ+รหัสสามตัว',
  threeCharacterCodeTooltip: 'รหัสสามตัว: MAWB Prefix',
  CustomerNoChinese: 'รหัสลูกค้า+ภาษาจีน',
  SupplierNoChinese: 'รหัสผู้จัดหา+ภาษาจีน',
  pageDisplay: 'การแสดงผลหน้า',
  required: 'จำเป็นต้องกรอกหรือไม่',
  b2bWebsite: 'เว็บไซต์ B2B',
  b2bWebsiteDisplay: 'การแสดงผลเว็บไซต์ B2B'
}
